module.exports = __webpack_public_path__ + "static/img/welcome-bonus-575x325.91b4fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welcome-bonus-575x325.jpg
// module id = tblt
// module chunks = 0